Wee.fn.make('home', {
	init: function() {
		var customButton = $.get('customButton');

		Wee.identoMap.initSearch({
			mapUrl: '/locations'
		});

		if (customButton) {
			$('head').append($.view.render('button-style', customButton));
		}
	}
});
